import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

/**
 * check if your subscribtion is NEWS or ALL
 */
export const newsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.authToken();
  if (
    user?.groups?.includes('SUBSCRIPTION_ALL') ||
    user?.roles?.includes('SUBSCRIPTION_ALL') ||
    user?.groups?.includes('SUBSCRIPTION_NEWS') ||
    user?.roles?.includes('SUBSCRIPTION_NEWS')
  ) {
    return true;
  } else {
    router.navigate(['/message/nosubscription']);
    return false;
  }
};
